import * as React from 'react';
import { PropsWithChildren } from 'react';
import classNames from 'classnames';

export const OptionsList = ({
  children,
  component: Component = 'ul',
  className,
}: PropsWithChildren<{
  component?: React.ElementType;
  className?: string;
}>) => {
  return (
    <Component className={classNames('cp-options-list', className /*ThemeDefinition.listSelector.options*/)}>
      {children}
    </Component>
  );
};
